<template>
    <div></div>
</template>

<script>
    import {mapGetters} from "vuex";
    import ProductUtils from "@/components/product/ProductUtils";

    export default {
        name: "Utils",
        data: function(){
            return {
                cookie_order_timer: 'timer_interval_id',
                cookie_order_status: 'status_interval_id',
                cookie_online_payment: 'online_payment',
                cookie_online_payment_expired: (60*10),
                errors: [],
                ORDER_STATUS_NEW_WAITING_PAYMENT: 'NEW_WAITING_PAYMENT',
                ORDER_STATUS_DELAY_WAITING_COOKING: 'NEW_WAITING',
                ORDER_STATUS_CANCELLED: 'CANCELLED',
                ORDER_STATUS_CLOSED: 'CLOSED',
                COUPON_STATUS_NO_FOUND: 'COUPON_NO_FOUND',
                COUPON_STATUS_HAS_BEEN_APPLIED: 'COUPON_HAS_BEEN_APPLIED',
                COUPON_STATUS_HASNT_BEEN_APPLIED: 'COUPON_HASNT_BEEN_APPLIED',
                PICKUP_CLOSE_ORDER_TYPE: "P",
                DELIVERY_CLOSE_ORDER_TYPE: "D",
                FULLY_CLOSE_ORDER_TYPE: "DP"
            };
        },
        methods: {
            morph(c, t1, t2, t5){
                let text = c;
                if(c > 20 && c.toString().length > 1){
                    var tmp_c = c.toString().substr(-1);
                    if(parseInt(tmp_c) > 0){
                        c = tmp_c;
                    }
                }

                if(c == 1){
                    text = t1;
                }
                if(c >= 2 && c < 5){
                    text = t2;
                }
                if(c >= 5 || c == 0){
                    text = t5;
                }
                return text;
            },

            async sendRequest(command, params, method){
                const component = this;
                if(typeof params !== "object"){
                    params = {};
                }
                Object.assign(params, {devMode: this.isDevMode});
                const config = {headers: {"X-Bitrix-Csrf-Token": component.sessionId}};
                if(method !== undefined && method === "GET") {
                  return this.$http.get(
                      '/api/?action=' + command + '&city=' + component.cityCode,
                      Object.assign({params: params}, config)
                  );
                }else{
                  return this.$http.post('/api/?action=' + command + '&city=' + component.cityCode, params, config);
                }
            },

            prepareBasketOffer(product, selectedOffer, doughType){
              let offer = Object.assign({'entity': product.entity}, selectedOffer);
              offer['free_sauce'] = product.sauce_available;
              if(product.is_pizza){
                if (offer['doughs'] !== undefined) {
                  const variants = Object.assign({}, offer['doughs'][doughType]);
                  delete offer['doughs'];
                  offer['offer_id'] = offer['id'];
                  offer['id'] = variants['id'];
                  offer['code'] = variants['code'];
                  offer['dough'] = doughType;
                  offer['category'] = variants['category'];
                  offer['external_code'] = variants['external_code'];
                }
              }else if(product.offers.length > 0){
                offer['offer_id'] = offer['id'];
                const variants = Object.assign({}, offer.variants);
                offer['code'] = variants.code;
                offer['external_code'] = variants.external_code;
              }else if(product.offers.length === 0){
                if(offer.variants !== undefined){
                  const variants = Object.assign({}, offer.variants);
                  offer['code'] = variants.code;
                  offer['external_code'] = variants.external_code;
                }
              }
              if(offer.image === undefined || offer.image.length === 0){
                offer.image = product.image;
              }
              offer.only_pickup = product.only_pickup;
              offer.quantity = 1;
              offer.primary_id = product['id'];
              offer.group_id = product['group_id'];
              return offer;
            },

            doughTitle(dough){
                return dough === 'thick' ? this.phrases.DOUGH_THICK: this.phrases.DOUGH_THIN;
            },

            checkOrderStatus(order_id, payment_id){
                const component = this;
                component.errors = [];
                if(!component.isSentCheckOrderRequest) {
                    component.$store.commit('app/sentCheckOrderRequest', true);
                    component.sendRequest('check-order-status', {order_id: order_id, payment_id: payment_id}).then(response => {
                        component.$store.commit('app/sentCheckOrderRequest', false);
                        const data = response.data;
                        const orderInfo = response.data.order;
                        if (data.status === 'success'){
                            const status = orderInfo.statusCode;
                            if (status !== component.ORDER_STATUS_DELAY_WAITING_COOKING) {
                                if (status === component.ORDER_STATUS_CLOSED
                                    || status === component.ORDER_STATUS_CANCELLED) {
                                    component.closeOrder();
                                } else {
                                    if (component.order.status !== status) {
                                        const order = {
                                          id: order_id,
                                          number: orderInfo.number,
                                          status: status,
                                          statusText: orderInfo.status,
                                        };
                                        component.$store.dispatch({
                                            type: 'order/setOrderInfo',
                                            order: order,
                                        });
                                    }
                                    component.$store.commit('app/setWaitingOrderTime', data.waiting_time);
                                    component.runOrderTimer();
                                }
                            } else {
                                if(component.order.id !== order_id || component.order.number !== orderInfo.number
                                    || component.order.status !== status){
                                    component.$store.dispatch({
                                        type: 'order/setOrderInfo',
                                        order: {
                                          id: order_id,
                                          number: orderInfo.number,
                                          status: status
                                        },
                                    });
                                }
                            }
                        } else {
                            const error = this.orderError(data);
                            this.$store.commit("order/setOrderErrors", [component.errorText(error)]);
                            const order = {
                              id: order_id,
                              status: "SEND_ORDER_ERROR",
                              statusText: "Ошибка выполнения заказа",
                            };
                            component.$store.dispatch({
                              type: 'order/setOrderInfo',
                              order: order,
                            });
                            component.dropCookieIntervalTimer();
                        }
                    }).catch(error => {
                        console.log('Error', error);

                      this.$store.commit("order/addOrderError", error);
                    });

                    const status_interval_id = component.$cookies.get(component.cookie_order_status);
                    if (status_interval_id === null) {
                        component.$nextTick(function () {
                            const intervalId = window.setInterval(() => {
                                component.checkOrderStatus(order_id, payment_id);
                            }, 60000);
                            console.error('RUN TIMER CHECK ORDER STATUS', intervalId);
                            component.$cookies.set(component.cookie_order_status, intervalId);
                        });
                    }else {
                        console.error('NO RUN TIMER CHECK ORDER STATUS');
                    }
                }
            },

            changeOrderStatus(){
              var current_status = this.order.status;
              switch (current_status){
                case "Processing":
                  current_status = "CookingStartedDelivery";
                  break;
                case "CookingStartedDelivery":
                  current_status = "OnWay";
                  break;
                case "OnWay":
                  current_status = "Delivered";
                  break;
                case "Delivered":
                  current_status = "Processing";
                  break;
              }
              const order = {
                status: current_status,
                id: this.order.id,
              };

              this.$store.dispatch({
                type: 'order/setOrderInfo',
                order: order,
              });
            },

            setCheckout(){
                this.$store.dispatch({
                    type: 'order/setCheckout',
                    state: true,
                });
                this.$store.dispatch({
                    type: 'order/setConfirmOrder',
                    state: false,
                });
            },

            setConfirm(){
                this.$store.dispatch({
                    type: 'order/setCheckout',
                    state: false,
                });
                this.$store.dispatch({
                    type: 'order/setConfirmOrder',
                    state: true,
                });
            },

            clearDiscounts(){
              this.$store.dispatch({
                type: 'order/setDiscounts',
                discounts: [],
              });
            },

            calculateDiscount(skipQueueVerifier){
                const component = this;
                const callQueueVerifier = (skipQueueVerifier === undefined ? true : skipQueueVerifier);

                this.$store.commit("basket/setError", null);

                if(callQueueVerifier) {
                  component.discountQueueVerifier();
                }

                if(component.process_discount){
                  return ;
                }

                if(component.isOpenOrder()){
                    return false;
                }

                component.$store.commit("order/setOrderErrors", []);
                component.clearDiscounts();

                const order = this.collectOrderInfo(true);
                if(order.productItems.length) {
                  component.$store.commit('app/setProcessDiscount', true);

                  component.sendRequest('calculate-discounts', order).then(response => {
                    const data = response.data;
                    if (data.status === 'success') {
                      this.$store.dispatch({
                        type: 'order/setDiscounts',
                        discounts: data.discounts,
                      });
                      this.$store.dispatch({
                        type: 'order/setTotal',
                        total: {
                          sum: data.order_sum,
                          full_sum: data.order_full_sum,
                          discount_sum: data.order_discount_sum,
                          free_sauces_count: data.free_sauces_count
                        },
                      });

                      const isFreeProduct = (data['free_products'] !== undefined && data['free_products'] !== null && Object.keys(data.free_products));
                      const isProductsForAdd = (data['products_for_add'] !== undefined && data['products_for_add'] !== null && Object.keys(data.products_for_add));
                      if (isFreeProduct || isProductsForAdd) {
                        const free_products = isFreeProduct ? data.free_products : data.products_for_add;
                        for (const product_id in free_products) {
                          const product = this.productList.find(product => parseInt(product.id) === parseInt(product_id));
                          if (product !== undefined) {
                            const freeProduct = free_products[product_id];
                            const orderFreeProduct = component.$store.getters['order/basketItems']
                                .filter(item => (item.isShareItem && item.external_code === freeProduct['code'])).pop();

                            if (orderFreeProduct !== undefined) {
                              if (orderFreeProduct.quantity < freeProduct['quantity']) {
                                Object.assign(freeProduct.quantity, (freeProduct.quantity - orderFreeProduct.quantity));
                              } else if (orderFreeProduct.quantity > freeProduct['quantity']) {
                                this.$store.dispatch({
                                  type: 'order/changeQuantity',
                                  code: orderFreeProduct.code,
                                  quantity: (freeProduct['quantity'] - orderFreeProduct.quantity),
                                });
                                continue;
                              } else {
                                continue;
                              }
                            }

                            if (product.offers !== undefined && product.offers.length > 0) {
                              const offer_id = free_products[product_id]['offer_id'];
                              const product_offer = product.offers.find(o => parseInt(o.id) === parseInt(offer_id));
                              const offer = Object.assign({
                                    isShareItem: true,
                                    quantity: freeProduct.quantity,
                                    isFreeItem: isFreeProduct
                                  },
                                  this.prepareBasketOffer(product, product_offer, 'thick'));
                              this.$store.dispatch({
                                type: 'order/addToBasket',
                                offer: offer,
                              });
                            } else {
                              const offer = Object.assign({
                                    isShareItem: true,
                                    quantity: freeProduct.quantity,
                                    isFreeItem: isFreeProduct
                                  },
                                  this.prepareBasketOffer(product, this.prepareSelectedProductWithoutOffer(product)));
                              this.$store.dispatch({
                                type: 'order/addToBasket',
                                offer: offer,
                              });
                            }
                          }
                        }
                      } else {
                        const freeProducts = order.productItems.filter(item => item.isShareItem);
                        for (const product of freeProducts) {
                          this.$store.commit('order/removeBasketItem', product.code);
                        }
                      }

                      this.$store.commit('order/setCouponStatus', null);
                      const couponValue = order['coupon'] !== undefined && order['coupon'] !== null && order['coupon'].length;
                      if (couponValue) {
                        const warnings = data.warnings !== undefined ? data.warnings : [];
                        const isAppliedCoupon = data.discounts !== undefined && data.discounts.length;
                        const emptyDiscount = !isAppliedCoupon;
                        if (warnings.length || emptyDiscount) {
                          if (warnings.length && warnings[0].search(/Coupon is not found/) >= 0) {
                            this.$store.commit('order/setCouponStatus', component.COUPON_STATUS_NO_FOUND);
                          } else {
                            this.$store.commit('order/setCouponStatus', component.COUPON_STATUS_HASNT_BEEN_APPLIED);
                          }
                        }
                        if (isAppliedCoupon) {
                          this.$store.commit('order/setCouponStatus', component.COUPON_STATUS_HAS_BEEN_APPLIED);
                        }
                      }
                    } else {
                      this.$store.commit("basket/setError", data.error);
                      this.$store.commit("order/addOrderError", component.errorText(data.error));
                    }
                  }).finally(function () {
                    component.$store.commit('app/setProcessDiscount', false);
                    if(component.isDiscountQueue){
                      component.calculateDiscount(false);
                    }
                    component.$store.commit('basket/setDiscountQueue', false);
                  });
                }else{
                  component.$store.commit('app/setProcessDiscount', false);
                }
            },

            discountQueueVerifier: function (){
              const component = this;
              if(component.process_discount && !component.isDiscountQueue){
                component.$store.commit('basket/setDiscountQueue', true);
              }
              return component.isDiscountQueue;
            },

            collectOrderInfo(withOutFree = false){
                let productItems = [];
                const isDelivery = this.isDelivery;
                if(isDelivery){
                    productItems = this.productItems.filter(item => !item.only_pickup);
                }else{
                    productItems = this.productItems;
                }

                if(this.freeProducts.length && !withOutFree){
                  for (const freeProduct of this.freeProducts){
                    productItems.push(freeProduct);
                  }
                }

                return {
                    user: {
                      id: this.user.id,
                      phone: this.user.phone,
                      name: this.user.name,
                      email: this.user.email,
                      external_id: this.user.external_id
                    },
                    isDelivery: this.isDelivery,
                    isDeferOrder: this.isDeferOrder,
                    deferOrderTime: this.deferOrderTime,
                    deferOrderDate: this.deferOrderDate !== null ? this.convertOrderDate(this.deferOrderDate, "-") : null,
                    paymentType: this.paymentType,
                    paymentCourierVariant: this.paymentCourierVariant,
                    noChange: this.noChange,
                    changeValue: !this.noChange ? this.changeValue : 0,
                    useBonus: this.useBonus,
                    bonusValue: this.useBonusValue,
                    address: this.deliveryAddress,
                    saveAddress: this.saveAddress,
                    comment: this.orderComment,
                    productItems: productItems,
                    total: this.total,
                    coupon: this.coupon,
                    city: this.city,
                    ts: this.ts,
                };
            },

            addFixedBodyClass(add) {
                const el = document.body;
                const bodyClass = 'fixed';
                if (add) {
                    el.classList.add(bodyClass);
                } else {
                    if(!this.isOpenMobileMenu) {
                        el.classList.remove(bodyClass);
                    }
                }
            },

            openMobileMenu: function () {
                this.$store.commit('app/openMobileMenu')
            },

            openFilter: function () {

                this.$store.commit('app/setOpenFilter')
            },

            runOrderTimer: function () {
                const component = this;
                const timerIntervalId = this.$cookies.get(this.cookie_order_timer);
                if(timerIntervalId === null){
                    this.$nextTick(function () {
                        const intervalId = window.setInterval(() => {
                            component.$store.commit('app/setWaitingOrderTime', (this.waitingOrderTime - 1));
                        }, 1000);
                        component.$cookies.set(component.cookie_order_timer, intervalId);
                    });
                }else {
                    console.error('NO START ORDER TIMER');
                }
            },

            errorText: function (errorCode) {
                if(errorCode !== undefined) {
                    return (this.phrases[errorCode] !== undefined) ? this.phrases[errorCode] : errorCode;
                }
                return "Unknown error"
            },

            closeOrder(){
                const component = this;
                if(this.$cookies.isKey('order')){
                    this.$cookies.remove('order');
                }
                this.$store.dispatch({
                    type: 'order/closeOrder',
                    order: {'id': this.order.id},
                }).then(function () {
                    component.order.id = null;
                    component.dropCookieIntervalTimer();
                    component.$store.commit('app/setWaitingOrderTime', 0);
                    window.location.reload();
                });
            },

            sendOrderToGoogleTagManager: function (order_id, order){
                const component = this;
                if(!component.isDevMode) {
                    if(component.$gtm !== undefined && component.$gtm.dataLayer !== undefined) {
                        const transactionItems = [];
                        const orderBasketItems = order.productItems;
                        for (const basketItemKey in orderBasketItems) {
                            const basketItem = orderBasketItems[basketItemKey];
                            const transactionItem = {
                                'sku': basketItem.external_code,
                                'name': basketItem.title,
                                'category': basketItem.category,
                                'price': basketItem.price,
                                'quantity': basketItem.quantity
                            };
                            transactionItems.push(transactionItem);
                        }
                        const transaction = {
                            'transactionId': order_id,
                            'transactionAffiliation': this.cityCode,
                            'transactionTotal': order.total.sum,
                            'transactionTax': '0',
                            'transactionShipping': '0',
                            'transactionProducts': transactionItems
                        };
                      component.$gtm.dataLayer.push(transaction);
                    }
                }
            },

            dropCookieIntervalTimer(){
                if(this.$cookies.isKey(this.cookie_order_timer)){
                    const intervalId = this.$cookies.get(this.cookie_order_timer);
                    if(!isNaN(intervalId)){
                        this.$cookies.remove(this.cookie_order_timer);
                        window.clearInterval(intervalId);
                    }
                }
                if(this.$cookies.isKey(this.cookie_order_status)){
                    const intervalId = parseInt(this.$cookies.get(this.cookie_order_status));
                    if(!isNaN(intervalId)){
                        this.$cookies.remove(this.cookie_order_status);
                        window.clearInterval(intervalId);
                    }
                }
            },

            checkUserAuth: function(){
                const component = this;
                this.sendRequest('check-authorize').then(response => {
                    const result = response.data;
                    if (result.status === 'success'){
                        const result = response.data;
                        const user = result.user;
                        this.$store.dispatch({
                            type: 'user/setUserInfo',
                            user: user,
                        });
                        this.$store.dispatch({
                            type: 'order/setUserInfo',
                            user: user,
                        });
                        component.updateSessionId(response.headers.session_id);
                    }
                });
            },

            setChangeLocation: function () {
              this.$store.commit('app/setChangeLocation');
            },

            addLeadZeroToDatePart: function (datePart){
              return datePart.toString().length === 1 ? ('0' + datePart) : datePart;
            },

            isOpenOrder(){
              return this.order.id !== null;
            },

            declineOrderWithIncreaseTime(){
              this.$store.commit('app/setShowIncreaseOrderTimeConformation', false);
            },

            declineOrderWithPaidDelivery(){
              this.$store.commit('app/setShowPaidDeliveryConfirmation', false);
            },

            convertOrderDate: function (date, delimiter){
              delimiter = delimiter === undefined ? "" : delimiter;
              return [date.year, ("0" + (date.month + 1)).slice(-2), ("0" + (date.date)).slice(-2)].join(delimiter);
            },

            updateSessionId: function(sessionId){
              this.$store.commit('app/setSessionId', sessionId);
            },

            isEmpty: function (value) {
              return value === undefined || value === null || value.length === 0;
            },

            orderError: function (response){
              if(response.order !== undefined && response.order.problem !== undefined){
                return response.order.problem;
              }
              if(response.error !== undefined){
                return response.error;
              }

              return "Unknown error occurred";
            }
        },
        computed: {
            ...mapGetters('order', {
                isDelivery: 'isDelivery',
                order: 'getOrderInfo',
                productItems: 'basketItems',
                freeProducts: 'getFreeProducts',
                total: 'total',
                total_quantity: 'getTotalQuantity',
                user: 'getUserInfo',
                coupon: 'getCoupon',
                isUseBonus: 'isUseBonus',
                useBonusValue: 'useBonusValue',
                pizzeria_point_id: 'getPizzeriaPointId',
                deferOrderDate: 'getDeferOrderDate'
            }),
            ...mapGetters('app', {
                phrases: 'getPhrases',
                isPizzeriaClosed: 'getIsPizzeriaClosed',
                isOpenMobileMenu: 'isOpenMobileMenu',
                isDevMode: 'getIsDevMode',
                waitingOrderTime: 'getWaitingOrderTime',
                cityCode: 'getCityCode',
                isSentCheckOrderRequest: 'getIsSentCheckOrderRequest',
                pizzeriaInfo: 'getPizzeriaInfo',
                process_discount: 'getProcessDiscount',
                time: 'currentTime',
                sessionId: 'getSessionId'
            }),
            ...mapGetters('catalog', {
              productList: 'getProductList',
              stopList: 'getStopList',
            }),
            ...mapGetters('user', {
              user: 'getInfo',
            }),
            ...mapGetters('basket', {
              isDiscountQueue: 'getDiscountQueue',
              preOrderSchedule: 'getPreOrderSchedule',
            }),
            dateSchedule: function (){
              const orderDate = this.convertOrderDate(this.deferOrderDate);
              const deliveryType = this.isDelivery ? "delivery" : "pickup";
              return this.preOrderSchedule[orderDate] ? this.preOrderSchedule[orderDate]['preorder'][deliveryType] : null;
            },
            deferOrderStart: function () {
                if(this.dateSchedule) {
                  return this.dateSchedule['start'];
                }
                return null;
            },
            deferOrderFinish: function () {
                if(this.dateSchedule) {
                  return this.dateSchedule['finish'];
                }
                return null;
            },
            tomorrowDate: function () {
                const ts = this.$store.state.app.ts;
                return this.$moment(ts.tomorrow.start_ts).format('DD:MM');
            },
            plates: function () {
                return this.morph(this.total_quantity, this.phrases.DISH, this.phrases.DISH_2, this.phrases.DISHES);
            },
            total_order_sum: function (){
              let total_sum = this.total.sum;
              if(this.isUseBonus){
                total_sum -= this.useBonusValue
              }
              return total_sum;
            },
            pizzeriaCloseOrderType: function (){
              return this.pizzeriaInfo.hand_close.type_code;
            },
            fullyCloseOrderType: function (){
              return this.pizzeriaCloseOrderType === this.FULLY_CLOSE_ORDER_TYPE;
            },
            closeDeliveryOrderType: function (){
              return this.pizzeriaCloseOrderType === this.DELIVERY_CLOSE_ORDER_TYPE;
            },
            closePickupOrderType: function (){
              return this.pizzeriaCloseOrderType === this.PICKUP_CLOSE_ORDER_TYPE;
            }
        },
        mounted() {
            //DENIED ANY CODE
        },
        mixins: [ProductUtils],
    }
</script>

<style scoped>

</style>
